import React from 'react';

const VelocityChart = ({ sprints, selectedProject }) => {
  const completedSprints = sprints
    .filter(sprint => sprint.status === 'completed')
    .filter(sprint => selectedProject === 'all' || sprint.projectId === selectedProject)
    .slice(-5); // Last 5 sprints

  if (completedSprints.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          Velocity Chart
        </h3>
        <div className="text-center py-12">
          <div className="text-gray-400 dark:text-gray-500 text-6xl mb-4">🚀</div>
          <p className="text-gray-500 dark:text-gray-400">
            No completed sprints to display velocity chart
          </p>
        </div>
      </div>
    );
  }

  const velocities = completedSprints.map(sprint => ({
    name: sprint.name,
    planned: sprint.velocity || 0,
    actual: sprint.completedIssues || 0,
    points: sprint.completedStoryPoints || 0
  }));

  const maxVelocity = Math.max(...velocities.map(v => Math.max(v.planned, v.actual, v.points))) * 1.2;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        Velocity Chart
      </h3>
      
      <div className="space-y-4">
        <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
          <div className="flex items-end justify-between h-40 space-x-2">
            {velocities.map((velocity, index) => (
              <div key={index} className="flex-1 flex flex-col items-center">
                <div className="flex items-end space-x-1 w-full justify-center">
                  {/* Planned velocity */}
                  <div 
                    className="w-1/3 bg-blue-500 rounded-t"
                    style={{ height: `${(velocity.planned / maxVelocity) * 100}%` }}
                    title={`Planned: ${velocity.planned}`}
                  ></div>
                  
                  {/* Actual completed issues */}
                  <div 
                    className="w-1/3 bg-green-500 rounded-t"
                    style={{ height: `${(velocity.actual / maxVelocity) * 100}%` }}
                    title={`Completed Issues: ${velocity.actual}`}
                  ></div>
                  
                  {/* Completed story points */}
                  <div 
                    className="w-1/3 bg-purple-500 rounded-t"
                    style={{ height: `${(velocity.points / maxVelocity) * 100}%` }}
                    title={`Story Points: ${velocity.points}`}
                  ></div>
                </div>
                <div className="text-xs text-gray-600 dark:text-gray-400 mt-2 text-center">
                  {velocity.name.split(' ').pop()}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center space-x-6 text-xs">
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 bg-blue-500 rounded"></div>
            <span>Planned</span>
          </div>
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 bg-green-500 rounded"></div>
            <span>Completed Issues</span>
          </div>
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 bg-purple-500 rounded"></div>
            <span>Story Points</span>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <div className="text-lg font-bold text-blue-600 dark:text-blue-400">
              {Math.round(velocities.reduce((sum, v) => sum + v.planned, 0) / velocities.length)}
            </div>
            <div className="text-sm text-gray-500 dark:text-gray-400">Avg Planned</div>
          </div>
          <div>
            <div className="text-lg font-bold text-green-600 dark:text-green-400">
              {Math.round(velocities.reduce((sum, v) => sum + v.actual, 0) / velocities.length)}
            </div>
            <div className="text-sm text-gray-500 dark:text-gray-400">Avg Completed</div>
          </div>
          <div>
            <div className="text-lg font-bold text-purple-600 dark:text-purple-400">
              {Math.round(velocities.reduce((sum, v) => sum + v.points, 0) / velocities.length)}
            </div>
            <div className="text-sm text-gray-500 dark:text-gray-400">Avg Points</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VelocityChart;